<template>
  <div>
    <querytitle>
      <template slot="queryleft">
        <div>单位及用户定义</div>
      </template>
    </querytitle>
    <el-table :data="itemlist" border style="width:100%" :height="hh" stripe size="mini" row-key="unit_id"
      default-expand-all>
      <el-table-column prop="unit_id" label="单位编号" width="180">
        <template slot-scope="scope">
          <i :class="scope.row.icon"></i>{{ scope.row.unit_id }}
        </template>
      </el-table-column>
      <el-table-column prop="unit_name" label="单位名称"></el-table-column>
      <el-table-column prop="unit_type" label="单位类型" width="210"></el-table-column>
      <el-table-column prop="is_valid" label="状态" width="150"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link icon="el-icon-plus" v-if="scope.row.unit_type != '文明单位'" @click="adds(scope)" type="success"
            size="mini">新增下属</el-link>
          <el-link icon="el-icon-check" @click="edit(scope)" type="primary" size="mini">编辑</el-link>
          <el-link icon="el-icon-close" v-if="scope.row.unit_type != '市级文明办'" type="danger" size="mini"
            @click="del(scope)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="单位及用户管理" :visible="dialogFormEdit" :show-close="false" width="80%">
      <el-form label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="单位编号">
              <el-input v-model="itemedit.unit_id" @input="inputmethod()" :disabled="!addflag">
                <template slot="prepend" v-if="addflag">{{ pid }}</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位类型">
              <el-select v-model="itemedit.unit_type" placeholder="请选择" :disabled="addflag == false"
                @input="inputmethod()">
                <el-option v-for="item in userlist" :label="item" :key="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
                <el-form-item label="单位状态">
                  <el-select v-model="itemedit.is_valid" placeholder="请选择" @input="inputmethod()">
                    <el-option v-for="item in isvalues" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
          <el-col :span="8">
            <el-form-item label="序号">
              <el-input v-model="itemedit.order_id" @input="inputmethod()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="单位名称">
              <el-input v-model="itemedit.unit_name" @input="inputmethod()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联络手机">
              <el-input v-model="itemedit.unit_tel" @input="inputmethod()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="itemedit.unit_type != '文明单位'">
            <el-form-item label="管理单位等级">
              <el-select v-model="managers" :multiple="true" style="width:500px;">
                <el-option v-for="item in levels" :key="item.dict_name" :value="item.dict_name" :label="item.dict_name">
                </el-option>
              </el-select>设置文明单位审核的最终审核机构
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="addflag == false">
            <querytitle>
              <template slot="queryleft">
                <b>用户列表</b>
              </template>
              <template slot="queryright">
                <el-button type="primary" size="mini" @click="adduser()">新增</el-button>
              </template>
            </querytitle>
            <el-table :data="users" border style="width:100%" height="350" stripe size="mini" row-key="login_code">
              <el-table-column prop="login_code" label="登录账号" width="120"></el-table-column>
              <el-table-column prop="user_name" label="用户姓名"></el-table-column>
              <el-table-column prop="user_role" label="用户角色" width="70"></el-table-column>
              <el-table-column prop="user_tel" label="联系电话" width="120"></el-table-column>
              <el-table-column prop="user_mobile" label="手机号码" width="150"></el-table-column>
              <el-table-column prop="user_qq" label="QQ号码" width="150"></el-table-column>
              <el-table-column prop="user_email" label="电子邮箱" width="150"></el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button @click="edituser(scope)" type="primary" size="mini">编辑</el-button>
                  <el-button type="danger" size="mini" @click="deluser(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormEdit = false">取 消</el-button>
        <el-button type="primary" @click="postdata()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="定义用户" :visible="dialogusers" :show-close="false" width="80%" append-to-body>
      <el-form label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录账号：">
              <el-input v-model="itemedituser.login_code" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户姓名：">
              <el-input v-model="itemedituser.user_name" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录密码：">
              <el-input v-model="login_pwd" type="password" @input="inputmethod()" placeholder="请输入内容"
                style="width:200px;"></el-input>
              <span ref="textPawStyle">{{ textPaw }}</span>
              <span style="font-size:12px;color:#ccc">(密码需要字母+数字长度超过6位)</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="再次输入密码：">
              <el-input v-model="itemedituser.login_pwd1" type="password" @input="inputmethod()" placeholder="请输入内容"
                style="width:200px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <el-input v-model="itemedituser.user_tel" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码：">
              <el-input v-model="itemedituser.user_mobile" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QQ号码：">
              <el-input v-model="itemedituser.user_qq" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱：">
              <el-input v-model="itemedituser.user_email" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户角色：">
              <el-select v-model="itemedituser.user_role" :disabled="CU.cu.orgtype == '县级文明办'">
                <el-option v-for="(item) in roles" :key="item.role_code" :value="item.role_code"
                  :label="item.role_name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户印章：">
              <el-input v-model="itemedituser.stamper" @input="inputmethod()" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogusers = false">取 消</el-button>
        <el-button type="primary" @click="editpostdata()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import querytitle from '@/components/querytitle'
import fileimportbutton from '@/components/fileimportbutton'
export default {
  components: {
    querytitle, fileimportbutton
  },
  data() {
    return {
      hh: 500,
      loading: false,
      addflag: false,
      itemlist: [],
      itemindex: 0,
      itemedit: {},
      pid: '',
      levels: [],
      managers: '',
      dialogFormEdit: false,

      dialogusers: false,
      addflaguser: false,
      itemedituser: {},
      itemindexuser: 0,
      roles: [],
      login_pwd:'',
      pars: { objname: 'sys_units' },
      querykey: "",
      userlist: ['县级文明办', '文明单位'],
      //isvalues: [{ value: '1', label: '有效' }, { value: '2', label: '无效' }],
      activeName: '单位信息',
      users: [],
      textPaw: '',
    };
  },
  watch: {
    'login_pwd': function (newPaw) {
      var pawValue = this.checkStrong(newPaw);
      if (pawValue < 1) {
        this.textPaw = ''
      }
      if (pawValue >= 1) {
        this.textPaw = '弱'
        this.$refs.textPawStyle.style.color = 'red'
      }
      if (pawValue >= 2 && pawValue < 4) {
        this.textPaw = '中'
        this.$refs.textPawStyle.style.color = 'orange'
      }
      if (pawValue == 4) {
        this.textPaw = '强'
        this.$refs.textPawStyle.style.color = 'green'
      }
    }
  },
  created() {
    this.hh = document.documentElement.clientHeight - 180;
    this.getlist();
    let that = this
    let wherestring = []
    let pars = { objname: "sys_roles", wheres: wherestring, PageSize: 9999, CurrentPage: 1 }
    that.PostData("Common/GETLIST", pars, function (res) {
      that.roles = res.data.data;
    }, function (err) {
      that.$alert(err, { title: "错误" });
    });
    that.GetDict('单位等级', function (res) {
      that.levels = res.data
    })
  },
  methods: {
    adds(par) {//
      this.addflag = true;
      this.itemedit.parent_unit = par.row.unit_id;
      if (par.row.unit_type == '市级文明办')
        this.userlist = ['县级文明办', '文明单位']
      else
        this.userlist = ['文明单位']
      this.pid = par.row.unit_id + '-';
      this.itemedit.unit_id = ''
      this.itemedit.unit_name = "";
      this.itemedit.unit_tel="";
      this.itemedit.unit_type = this.userlist[0];
      this.itemedit.is_valid = '有效'
      this.itemindex = par.$index;

      this.managers = []
      this.dialogFormEdit = true;
    },
    edit(par) {
      this.addflag = false;
      this.itemedit = Object.assign({}, par.row);
      this.itemindex = par.$index;
      this.managers = this.itemedit.unit_manager.split(',')
      this.getusers(this.itemedit.unit_id);
      console.log(this.itemedit)
      this.dialogFormEdit = true;
    },
    del: function (par) {
      let that = this;
      that.$confirm("确定要删除当前行吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var pars = { objname: "sys_units", model: par.row };
        that.PostData("Common/DEL", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" });
            return;
          }
          that.itemlist.splice(par.$index, 1);
        }, function (err) {
          that.$alert(err, { title: "错误", type: 'error' });
        }
        );
      })
        .catch(() => { });
    },
    postdata() {
      let that = this;
      if (!that.itemedit.unit_id) {
        that.$alert("单位代码不能为空", { title: "提示" }); return;
      }
      if (!that.itemedit.unit_name) {
        that.$alert("单位名称不能为空", { title: "提示" }); return;
      }
      if (!that.itemedit.unit_type) {
        that.$alert("单位类型不能为空", { title: "提示" }); return;
      }

      if (that.itemedit.unit_type == '文明单位')
        that.itemedit.unit_manager = ''
      else
        that.itemedit.unit_manager = that.managers.join(',')
      console.log(that.itemedit)
      let pars = { objname: "sys_units", model: Object.assign({}, that.itemedit) };
      if (that.addflag) {
        pars.model.unit_id = that.pid + pars.model.unit_id;
        that.PostData("Common/ADD", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" }); return;
          }
          //that.itemlist.push(pars.model);
          that.getlist();
          that.dialogFormEdit = false;
        }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
        );
      } else {
        that.PostData("Common/EDIT", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" }); return;
          }
          that.getlist();
          that.dialogFormEdit = false;
        }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
        );
      }
    },

    adduser() {
      this.addflaguser = true;
      this.itemedituser.login_code = '';
      this.itemedituser.user_name = '';
      this.login_pwd=''
      this.itemedituser.login_pwd = '';
      this.itemedituser.unit_id = this.itemedit.unit_id;
      if(this.CU.cu.orgtype == "县级文明办"){
        this.itemedituser.user_role = "A"
      }
      this.dialogusers = true;
    },
    edituser(par) {
      this.addflaguser = false;
      this.itemedituser = Object.assign({}, par.row);
      this.login_pwd = this.itemedituser.login_pwd;
      this.itemindexuser = par.$index;
      this.itemedituser.login_pwd1 = this.itemedituser.login_pwd;
      this.dialogusers = true;
    },
    deluser(par) {
      let that = this;
      that.$confirm("确定要删除当前用户吗？", "询问", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var pars = { objname: "sys_users", model: par.row };
        that.PostData("Common/DEL", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" });
            return;
          }
          that.itemlist.splice(par.$index, 1);
        }, function (err) {
          that.$alert(err, { title: "错误", type: 'error' });
        }
        );
      })
        .catch(() => { });
    },
    editpostdata() {
      let that = this;
      that.itemedituser.login_pwd = that.login_pwd;
      if (!that.itemedituser.login_code) {
        that.$alert("登录账号不能为空", { title: "提示" }); return;
      }
      if (!that.itemedituser.user_name) {
        that.$alert("姓名不能为空", { title: "提示" }); return;
      }
      if (that.itemedituser.login_pwd != that.itemedituser.login_pwd1) {
        that.$alert("两次输入的密码不一致！", { title: "提示" }); return;
      }
      if (that.textPaw == '' || that.textPaw == '弱') {
        this.$message({
          message: '密码太弱',
          type: 'warning'
        });
        return false;
      }      
      let pars = { objname: "sys_users", model: Object.assign({}, that.itemedituser) };
      if (that.addflaguser) {
        that.PostData("Common/ADD", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" }); return;
          }
          that.users.push(pars.model);
          that.dialogusers = false;
        }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
        );
      } else {
        that.PostData("Common/EDIT", pars, function (res) {
          if (res.data.error_code != 0) {
            that.$alert(res.data.message, { title: "错误" }); return;
          }
          that.$set(that.users, that.itemindexuser, pars.model);
          that.dialogusers = false;
        }, function (err) { that.$alert(err, { title: "错误", type: 'error' }); }
        );
      }
    },
    getlist() {
      let that = this
      let wherestring = []
      if (this.querykey) {
        wherestring = [{ field: 'unit_id', sym: 'like', val: this.querykey, oper: 'or' },]
      }
      that.GetData("SYS/GetUnits", { orgtype: '全部' }, function (res) {
        that.itemlist = res.data.data;
      }, function (err) {
        that.$alert(err, { title: "错误" });
      });
    },
    getusers(unitid) {
      let that = this
      let wherestring = [{ field: 'unit_id', sym: '=', val: unitid, oper: 'and' },]
      let pars = { objname: "sys_users", wheres: wherestring, PageSize: 9999, CurrentPage: 1 }
      that.PostData("Common/GETLIST", pars, function (res) {
        that.users = res.data.data;
      }, function (err) {
        that.$alert(err, { title: "错误" });
      });
    },
  }
};
</script>
